var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShieldCheckmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7838 15.7096C28.2098 15.2174 28.1562 14.4731 27.6641 14.0471C27.1719 13.6211 26.4277 13.6747 26.0017 14.1668L18.6606 22.6476L15.932 19.9744C15.4671 19.5189 14.7209 19.5266 14.2654 19.9915C13.8099 20.4565 13.8176 21.2027 14.2825 21.6582L17.9065 25.2087C18.1388 25.4362 18.4548 25.5577 18.7797 25.5443C19.1046 25.531 19.4096 25.384 19.6224 25.1381L27.7838 15.7096Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4851 4.43551C21.1767 4.29624 20.8233 4.29624 20.5149 4.43551C14.6555 7.08179 12.0252 7.92727 5.5371 9.09111C5.00286 9.18694 4.60315 9.63525 4.56898 10.177C3.3234 29.919 19.3445 36.7563 20.5597 37.2457C20.8422 37.3595 21.1578 37.3595 21.4403 37.2457C22.6555 36.7563 38.6766 29.919 37.431 10.177C37.3968 9.63525 36.9971 9.18694 36.4629 9.09111C29.9748 7.92727 27.3445 7.08179 21.4851 4.43551ZM21 34.8693C18.3735 33.6781 6.32082 27.3225 6.87652 11.2428C12.7397 10.1544 15.5756 9.23256 21 6.80198C26.4244 9.23256 29.2603 10.1544 35.1235 11.2428C35.6792 27.3225 23.6266 33.6781 21 34.8693Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCheckmark);
export default __webpack_public_path__ + "static/media/shield-checkmark.87541f3747766b3998626c4a1679da96.svg";
export { ForwardRef as ReactComponent };